import * as React from "react";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ImageIcon from "@mui/icons-material/Image";
import SegmentIcon from "@mui/icons-material/Segment";
import TableChartIcon from "@mui/icons-material/TableChart";
import SaveIcon from "@mui/icons-material/Save";

const ToolbarEditor = (props) => {
  const {
    onAddParagraph,
    onAddTable,
    onAddImage,
    onExportWord,
    onSave,
    ...others
  } = props;

  const addButtonsStyle = {
    background: "#32436d",
    ":hover": { background: "#14203e" },
  };

  const actionsButtonsStyle = {
    background: "#2b64ef",
    ":hover": { background: "#14203e" },
  };

  return (
    <Box
      gap={2}
      display="flex"
      direction="row"
      alignItems="center"
      style={{
        position: "sticky",
        height: "100px",
        top: "0px",
        background: "#f6f8fc",
        zIndex: 1,
      }}
    >
      {onAddParagraph && (
        <Button
          variant="outlined"
          startIcon={<SegmentIcon />}
          sx={addButtonsStyle}
          onClick={onAddParagraph}
        >
          Shto Paragraf
        </Button>
      )}
      <Button
        variant="outlined"
        startIcon={<TableChartIcon />}
        sx={addButtonsStyle}
        onClick={onAddTable}
      >
        Shto Tabele
      </Button>
      <Button
        variant="outlined"
        startIcon={<ImageIcon />}
        sx={addButtonsStyle}
        onClick={onAddImage}
      >
        Shto Imazh
      </Button>
      {onExportWord && (
        <Button
          startIcon={<FileDownloadIcon />}
          onClick={onExportWord}
          sx={actionsButtonsStyle}
        >
          Eksporto Word docx
        </Button>
      )}
      {onSave && (
        <Button
          startIcon={<SaveIcon />}
          onClick={onSave}
          sx={actionsButtonsStyle}
        >
          Ruaj
        </Button>
      )}
    </Box>
  );
};

export default ToolbarEditor;
